import { Alert, Stack, styled, Typography } from "@mui/material";
import StoreIcon from '@mui/icons-material/Store';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import { indigo } from "@mui/material/colors";
import { useEmisorConfig } from "@/features/facturacion-electronica/hooks/use-emisor-config";

const StyledAlert = styled(Alert)(({ theme }) => ({
    backgroundColor: indigo[700],
    color: theme.palette.common.white,
    paddingTop: 0,
    paddingBottom: 0,
}));

const iconSx = { fontSize: { xs: 12, sm: 14 }, color: "inherit", opacity: 0.8 };
const labelSx = { fontSize: { xs: "0.6rem", sm: "0.8rem" }, color: "inherit" };

export default function ConfigInfoChip() {
    const { config, isConfigValid } = useEmisorConfig();

    if (!isConfigValid || !config) {
        return (
            <Alert severity="warning" icon={false} sx={{ paddingTop: 0, paddingBottom: 0 }}>
                <Typography variant="subtitle2" sx={labelSx}>Config. pendiente</Typography>
            </Alert>
        );
    }

    return (
        <Stack direction="row" gap={1} alignItems="center">
            <StyledAlert icon={false}>
                <Stack direction="row" alignItems="center" gap={0.5}>
                    <StoreIcon sx={iconSx} />
                    <Typography variant="subtitle2" sx={{ ...labelSx, opacity: 0.8 }}>Est.</Typography>
                    <Typography variant="subtitle2" fontWeight={700} sx={labelSx}>{config.establecimiento}</Typography>
                </Stack>
            </StyledAlert>
            <StyledAlert icon={false}>
                <Stack direction="row" alignItems="center" gap={0.5}>
                    <PointOfSaleIcon sx={iconSx} />
                    <Typography variant="subtitle2" sx={{ ...labelSx, opacity: 0.8 }}>Exp.</Typography>
                    <Typography variant="subtitle2" fontWeight={700} sx={labelSx}>{config.puntoExpedicion}</Typography>
                </Stack>
            </StyledAlert>
        </Stack>
    );
}
